<div class="container">
  <div class="left-image">
    <img alt="workinsync" src="../../../../../../assets/left.svg" />
  </div>
  <div class="content">
    <div class="logo">
      <img style="padding-right: 20px" alt="workinsync" class="mr-md" src="../../../../../../assets/mis.svg" />
      <img style="padding-left: 20px" alt="workinsync" class="mr-md" src="../../../../../../assets/WIS-full.svg" />
    </div>
    <div class="main">
      <span class="label"> Mobile Application Management </span>
      <div (click)="requestGoogleLogin()" class="google-sign-in" role="button" tabindex="0">
        <img alt="google" class="mr-md" src="../../../../../../assets/google.ico" />
        Log in with Google
      </div>
      <div class="seprater">
        <span class="line"></span>
        <!-- <span class="text">OR</span> -->
        <span class="line"></span>
      </div>
    </div>

    <div class="right-image">
      <img src="../../../../../../assets/right.svg" />
    </div>
  </div>
</div>
